import { registerPlugin } from '@capacitor/core';
const NativePdfViewer = registerPlugin('NativePdfViewer', {
    web: () => import('./web').then((m) => new m.NativePdfViewerWeb()),
});
export * from './definitions';
export { NativePdfViewer };
//# sourceMappingURL=index.js.map